// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 基础设置
import BasicSet from '@/views/adminSet/basicSet';
// 支付设置
import PaySet from '@/views/adminSet/paySet';
// 模式参数设置
import ModeSet from '@/views/adminSet/modeSet';
// 级别设置
import LevelSet from '@/views/adminSet/levelSet';
// 轮播列表
import OtherSet from '@/views/adminSet/otherSet';
// 分红池
import LevelHave from '@/views/adminSet/levelHave';
// 公告列表
import NoteSet from '@/views/adminSet/noteSet';
// 公告编辑
import NoteAddSet from '@/views/adminSet/noteAddSet';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
import Goods from '@/views/pay/Goods';
import GoodsCLass from '@/views/pay/GoodsCLass';
import AddGoods from '@/views/pay/AddGoods';
/**
 * 系统管理
 */
// 会员列表
import user from '@/views/system/user';
// 商家审核
import userList from '@/views/system/userList';
// 其他商家审核
import moreList from '@/views/system/moreList';
// 店铺列表
import shop from '@/views/system/shop';
// 角色管理
import Role from '@/views/system/Role';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/basicSet',
            name: '基础设置',
            component: BasicSet,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/paySet',
            name: '代理模式设置',
            component: PaySet,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/modeSet',
            name: '模式参数设置',
            component: ModeSet,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/levelSet',
            name: '级别价格设置',
            component: LevelSet,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/levelHave',
            name: '分红池',
            component: LevelHave,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/otherSet',
            name: '轮播列表',
            component: OtherSet,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/noteSet',
            name: '公告列表',
            component: NoteSet,
            meta: {
                requireAuth: true
            }
        },{
            path: '/adminSet/noteAddSet',
            name: '编辑公告',
            component: NoteAddSet,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '订单列表',
            component: Order,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pay/Goods',
            name: '商品列表',
            component: Goods,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pay/GoodsCLass',
            name: '商品分类列表',
            component: GoodsCLass,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pay/AddGoods',
            name: '商品分类列表',
            component: AddGoods,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '会员列表',
            component: user,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/userList',
            name: '商家审核',
            component: userList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/shop',
            name: '商家审核',
            component: shop,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/moreList',
            name: '其他商家审核',
            component: moreList,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/Permission',
            name: '权限分配',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js